import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";

import { ProjectContext } from "@/stores/project-provider";

import { createItemUpdaterForQueryLists } from "./hooks/create-item-updater-for-query-list";
import { QueryListReturn } from "./types/query-return";

// Single

const getProjectUserListQuery = (projectId: string, searchString?: string) => {
  const search = searchString && searchString.length > 2 ? searchString : undefined;
  return getRanaApiV1().getQueryOptions({
    queryKey: ["projects", "users", projectId, search],
    queryFn: async () => getRanaApiV1().ProjectsApi.projectUserList({ projectId, search }),
  });
};

export const useProjectUserListQuery = (searchString?: string) => {
  const { id: projectId } = useContext(ProjectContext);
  return useQuery(getProjectUserListQuery(projectId, searchString));
};

// INVALIDATION

export const useInvalidateProjectUsersQuery = () => {
  const queryClient = useQueryClient();
  const { id: projectId } = useContext(ProjectContext);

  return async () => {
    await queryClient.invalidateQueries({
      queryKey: getProjectUserListQuery(projectId).queryKey.slice(0, -1),
      refetchType: "all",
    });
  };
};

type ProjectUserQueryItem = QueryListReturn<typeof getProjectUserListQuery>;

export const useUpdateProjectUsersQuery = () => {
  const { id: projectId } = useContext(ProjectContext);
  const queryClient = useQueryClient();

  return createItemUpdaterForQueryLists<ProjectUserQueryItem>(queryClient, {
    getQueryKey: () => getProjectUserListQuery(projectId).queryKey.slice(0, -1),
    getItemId: ({ user }) => user?.id,
  });
};
